<template>
  <button
    :id="id"
    @click="submit"
    type="submit"
    class="elr-button"
    :class="classes"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'ButtonSubmit',
  props: {
    classes: {
      type: String,
      default: 'elr-button-primary'
    },
    id: {
      type: String
    }
  },
  methods: {
    submit() {
      this.$emit('submit');
    }
  }
}
</script>
